module.exports = __webpack_public_path__ + "static/media/oriental.3b93b3d2.png";